// src/hooks/connectivityHooks/useReadExpertActivity.ts
import { useState, useEffect } from 'react';
import { io } from 'socket.io-client';

const SOCKET_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';

export const useReadExpertActivity = (expertCodes: string[] = []) => {
  const [expertMap, setExpertMap] = useState<
  Record<
    string,
    {
      status: string;
      isAvailableChat?: boolean;
      isAvailableCall?: boolean;
      isAvailableVideoCall?: boolean;
    }
  >
>({});

  const trackingString = expertCodes.join(',');

  useEffect(() => {
    if (!trackingString) {
      return;
    }

    const codesArray = trackingString.split(',');
    
    // 🟢 Grab current user or session tracking token fallback to prevent "Unknown" alerts
    const localUserCode = localStorage.getItem('user_code') || 'guest_listener';

    const presenceSocket = io(SOCKET_URL, {
      path: '/socket.io/',
      transports: ['websocket'],
      upgrade: false,
      // 🟢 FIX: Provide a senderCode so the backend gateway assigns identity cleanly
      query: { 
        senderCode: localUserCode, 
        senderType: 'presence_listener' 
      }
    });

   presenceSocket.on('connect', () => {
   

    presenceSocket.emit('request_presence', {
        expertCodes: codesArray,
    });
});

presenceSocket.io.on('reconnect', () => {
  

    presenceSocket.emit('request_presence', {
        expertCodes: codesArray,
    });
});
    // 🟢 FIX: Listen for a direct batch response containing the active current states of all tracked experts
presenceSocket.on(
  'initial_presence_snapshot',
  (snapshot: Record<string, any>) => {
    setExpertMap((prev) => ({
      ...prev,
      ...snapshot,
    }));
  },
);

  presenceSocket.on(
  'expert_presence_update',
  (data: { expertCode: string; status: string }) => {
    setExpertMap((prev) => ({
      ...prev,
      [data.expertCode]: {
        ...(prev[data.expertCode] || {}),
        status: data.status,
      },
    }));
  },
);
presenceSocket.on(
  'expert_availability_update',
  (data: {
    expertCode: string;
    isAvailableChat: boolean;
    isAvailableCall: boolean;
    isAvailableVideoCall: boolean;
  }) => {
    setExpertMap((prev) => ({
      ...prev,
      [data.expertCode]: {
        ...(prev[data.expertCode] || {}),
        isAvailableChat: data.isAvailableChat,
        isAvailableCall: data.isAvailableCall,
        isAvailableVideoCall: data.isAvailableVideoCall,
      },
    }));
  },
);

    return () => {
      presenceSocket.disconnect();
    };
  }, [trackingString]);

  return expertMap;
};